
import React from 'react';
import { Container, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";


const IdCard = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faFileContract} className="me-2" />
            Issuing of ID Card
          </h3>
        </Container>
      </div>

      {/* <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faFileContract} className="me-2" />
              Policy Documents
            </h4>
          </div>
          <CardBody className="p-4">
            
          </CardBody>
        </Card>
      </Container> */}
    </>
  );
}

export default IdCard